// Local source of truth for the pulse request envelope. The deployed contract's
// PulseBatchBody is an empty `object` (stale swagger metadata), so we type the event
// here with required fields + tight unions. The drift test (taxonomy.spec.ts) pins
// event names + prop keys to the backend registry.
export type AnonIdStorage = 'local' | 'memory';
export type ConsentTier = 'essential' | 'statistics' | 'marketing';
export type PulseSource = 'curewiki';

export const PULSE_SOURCE: PulseSource = 'curewiki';
// Pulse is a statistics-tier signal (behavioural analytics), not strictly-necessary
// "essential". Labelled honestly to match the Usercentrics categories; consent sourcing
// still lands later (see spec "Consent model").
export const PULSE_CONSENT_TIER: ConsentTier = 'statistics';
export const PULSE_CONSENT_POLICY_VERSION = 'v0-statistics';

export type PulseProps = Record<string, string | number | boolean | null>;

export interface PulseEventEnvelope {
  anonIdStorage: AnonIdStorage;
  clientTs: string;
  consentPolicyVersion?: string;
  consentTier: ConsentTier;
  cwAnonId: string;
  cwSessionId: string;
  cwUserId?: string;
  eventId: string;
  eventName: string;
  language?: string;
  pageUrl?: string;
  props?: PulseProps;
  referrer?: string;
  source: PulseSource;
}
